import * as z from "zod";
import {ModifyV2Dto} from "../../../model/ModifyV2Dto";
import {DEFAULT_REGISTER_V2_DTO, RegisterV2Dto} from "../../../model/RegisterV2Dto";
import {TaxAccountantDetailV2Dto} from "../../../model/TaxAccountantDetailV2Dto";

export const REQUEST_TYPE = ["INSERT", "UPDATE"] as const;
export const REQUEST_TYPE_TYPE = z.enum(REQUEST_TYPE);
export type REQUEST_TYPE_TYPE = z.infer<typeof REQUEST_TYPE_TYPE>;

const commonSchema = z.object({});

const updateSchema = commonSchema.extend({
	requestType: z.literal("UPDATE"),
	modifySnapshotDto: z.object({
		before: TaxAccountantDetailV2Dto.model,
		after: ModifyV2Dto.model
	})
});

const insertSchema = commonSchema.extend({
	requestType: z.literal("INSERT"),
	registerDto: RegisterV2Dto.model
});

const schema = z.discriminatedUnion("requestType", [updateSchema, insertSchema]);

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantApprovalRequestResModel = {schema, model};
export type ITaxAccountantApprovalRequestResModel = z.infer<typeof TaxAccountantApprovalRequestResModel.model>;

export const DEFAULT_TAX_ACCOUNTANT_APPROVAL_REQUEST_RES: ITaxAccountantApprovalRequestResModel = {
	requestType: "INSERT",
	registerDto: DEFAULT_REGISTER_V2_DTO
};
